(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amperepoint-manuals"] && !Shopify.designMode) return;
  try {
    
  const initAmpManuals = (root) => {
    if (!root || root.dataset.manualsReady === 'true') return;
    root.dataset.manualsReady = 'true';
    const search = root.querySelector('[data-manual-search]');
    const filters = root.querySelectorAll('[data-manual-filter]');
    const cards = root.querySelectorAll('[data-manual-card]');
    const empty = root.querySelector('[data-manual-empty]');
    const count = root.querySelector('[data-manual-count]');
    let activeFilter = 'all';
    const normalize = (value) => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const update = () => {
      const term = normalize(search ? search.value : '');
      let visible = 0;
      cards.forEach((card) => {
        const matchesFilter = activeFilter === 'all' || card.dataset.category === activeFilter;
        const matchesSearch = !term || normalize(card.dataset.search).includes(term);
        const show = matchesFilter && matchesSearch;
        card.hidden = !show;
        card.style.display = show ? '' : 'none';
        if (show) visible += 1;
      });
      if (count) {
        const singular = root.dataset.manualCountOne || 'manual';
        const plural = root.dataset.manualCountOther || 'manuals';
        count.textContent = `${visible} ${visible === 1 ? singular : plural}`;
      }
      if (empty) empty.classList.toggle('is-visible', visible === 0);
    };
    if (search) search.addEventListener('input', update);
    filters.forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.manualFilter;
        filters.forEach((filter) => filter.setAttribute('aria-pressed', String(filter === button)));
        update();
      });
    });
    update();
  };
  const initAllAmpManuals = (scope) => {
    const rootScope = scope || document;
    if (rootScope.matches && rootScope.matches('[data-amp-manuals]')) {
      initAmpManuals(rootScope);
      return;
    }
    rootScope.querySelectorAll('[data-amp-manuals]').forEach(initAmpManuals);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllAmpManuals(document));
  } else {
    initAllAmpManuals(document);
  }
  document.addEventListener('shopify:section:load', (event) => initAllAmpManuals(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
